import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { Datetime } from "vue-datetime";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue-popperjs/dist/vue-popper.css";

import "./permission.js"; // permission control
// You need a specific loader for CSS filesaa
import "vue-datetime/dist/vue-datetime.css";
import store from "./store";
// For validation
import Vuelidate from "vuelidate";
// If you don't need the styles, do not connect
// import * as Keycloak from "keycloak-js";
// import checkToken from "./utils/tokenCheck.js";
// Editor for long question
import "../src/assets/css/style.css";
import "../src/assets/css/typography.css";
import "../src/assets/css/globalStyle.css";

import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";

Vue.use(mavonEditor);
Vue.use(Vuelidate);
Vue.use(DatePicker);

Vue.use(Datetime);
Vue.component("datetime", Datetime);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.config.productionTip = false;

// GLobal Variable
Vue.prototype.$mirana = true;

// https://auth.simplifycv.com/auth/  // Production Auth
// http://sso.simplifycv.com/auth // Development Auth

// let initOptions = {
//   url: "http://sso.simplifycv.com/auth",
//   realm: "SimplifyCV",
//   clientId: "vue-test-app",
//   onLoad: "login-required"
// };
// let keycloak = Keycloak(initOptions);
// keycloak
//   .init({ onLoad: initOptions.onLoad })
//   .then(auth => {
//     if (!auth) {
//       Vue.prototype.$keycloakvar = keycloak;
//     } else {
//       // localStorage.setItem("vue_token", keycloak.token);
//       Vue.prototype.$keycloakvar = keycloak;
//       // Calls & Saves The Data in USER VUEX
//       if (checkToken())
//     }
//     new Vue({
//       el: "#app",
//       router,
//       store,
//       render: h => h(App)
//     });

//
//   })
//   .catch(() => {
//
//   });

function filterControlCharacters(value) {
	return value
		.split("")
		.filter((char) => char.charCodeAt(0) >= 32 || char.charCodeAt(0) === 9)
		.join("");
}

function safeHTML(htmlString) {
	let doc = document.implementation.createHTMLDocument("");

	let div = doc.createElement("div");

	div.innerHTML = htmlString;

	for (
		let elements = div.querySelectorAll("*"), i = elements.length - 1;
		i >= 0;
		i--
	) {
		let element = elements[i],
			tagName = element.localName;

		if (
			tagName == "script" ||
			tagName == "noscript" ||
			tagName == "noembed" ||
			!(element.attributes instanceof NamedNodeMap)
		) {
			try {
				element.parentNode.removeChild(element);
			} catch (e) {
				element.outerHTML = "";
			}

			continue;
		}

		if (!element.hasAttributes()) continue;

		for (
			let attributes = element.attributes, j = attributes.length - 1;
			j >= 0;
			j--
		) {
			let attribute = attributes[j],
				attributeName = attribute.localName,
				attributeValue = filterControlCharacters(attribute.value.trim());

			handleAttribute(element, attributeName, attributeValue);
		}
	}

	return div.innerHTML;
}

function handleAttribute(element, attributeName, attributeValue, tagName) {
	if (
		attributeName.startsWith("on") ||
		(["src", "href"].includes(attributeName) &&
			attributeValue.indexOf("javascript:") === 0) ||
		(["audio", "image", "img", "source", "video"].indexOf(tagName) === -1 &&
			["src", "data"].includes(attributeName) &&
			attributeValue.indexOf("data:") === 0)
	) {
		element.removeAttribute(attributeName);
	}
}

Vue.directive("html-safe", {
	// For Vue 2.x

	inserted: function(el, binding) {
		el.innerHTML = safeHTML(binding.value);
	},

	// For Vue 2.x

	update: function(el, binding) {
		if (binding.value !== binding.oldValue)
			el.innerHTML = safeHTML(binding.value);
	},

	unbind: function(el) {
		el.innerHTML = "";
	},
});

new Vue({
	el: "#app",
	router,
	store,
	render: (h) => h(App),
});

// Filter for topic name  length(listView)
Vue.filter("topicNameFilter", function(value) {
	if (value.length <= 24) {
		return value;
	} else {
		return value.slice(0, 19) + "...";
	}
});

Vue.filter("accesscontrolroles", function(value) {
	if (value.length <= 50) {
		return value;
	} else {
		return value.slice(0, 49) + "...";
	}
});

Vue.filter("confiftaggedto", function(value) {
	if (value.length <= 35) {
		return value;
	} else {
		return value.slice(0, 34) + "...";
	}
});

Vue.filter("accesscontrolrolesdesc", function(value) {
	if (value.length <= 65) {
		return value;
	} else {
		return value.slice(0, 64) + "...";
	}
});
Vue.filter("accesscontroluser", function(value) {
	if (value.length <= 32) {
		return value;
	} else {
		return value.slice(0, 31) + "...";
	}
});

Vue.filter("filetrEmails", function(value) {
	if (value.length <= 20) {
		return value;
	} else {
		return value.slice(0, 20) + "...";
	}
});

Vue.filter("filetrEmailsEditGroup", function(value) {
	if (value.length <= 45) {
		return value;
	} else {
		return value.slice(0, 45) + "...";
	}
});
Vue.filter("accesscontLandingPage", function(value) {
	if (value.length <= 25) {
		return value;
	} else {
		return value.slice(0, 24) + "...";
	}
});
Vue.filter("accesscontrolrolesOne", function(value) {
	if (value.length <= 32) {
		return value;
	} else {
		return value.slice(0, 31) + "...";
	}
});

Vue.filter("sharelinkname", function(value) {
	if (value.length <= 30) {
		return value;
	} else {
		return value.slice(0, 29) + "...";
	}
});
Vue.filter("sharelinkMain", function(value) {
	if (value.length >= 30) {
		return value.slice(0, 25) + "...";
	}
});
Vue.filter("testNameFilter", function(value) {
	if (value.length <= 24) {
		return value;
	} else {
		return value.slice(0, 19) + "...";
	}
});

// Filter for topic description  length(listView)
Vue.filter("snippet", function(value) {
	if (value.length <= 99) {
		return value;
	} else {
		return value.slice(0, 100) + "...";
	}
});
// Filter for topic card description  length(listView)
Vue.filter("snippetgrid", function(value) {
	if (value.length <= 69) {
		return value;
	} else {
		return value.slice(0, 70) + "...";
	}
});
// Filter for topic card description on hover length(listView)
Vue.filter("snippetgridhover", function(value) {
	if (value.length <= 510) {
		return value;
	} else {
		return value.slice(0, 511) + "...";
	}
});

// Filter for topic name  length(gridView)
Vue.filter("snippet_one", function(value) {
	if (value.length <= 20) {
		return value;
	} else {
		return value.slice(0, 30) + "...";
	}
});

// Filter for Questionbank to get questionKey value into 4 letters
Vue.filter("quesfilter", function(value) {
	return value.substring(0, 4);
});

// Filter for Questionbank Date created
Vue.filter("datefilter", function(value) {
	if (value) {
		let substr = value.substring(0, 10).split("-");
		substr = substr.reverse();
		substr = substr.join("-");
		return substr;
	}
});
Vue.filter("timefilter", function(value) {
	return value.substring(11, 16);
});

// Filter for Mcq & MAFO question length
Vue.filter("MMQfilter", function(value) {
	if (value.length <= 100) {
		return value;
	} else {
		return value.slice(0, 101) + "...";
	}
});
Vue.directive("closeArray", {
	bind(el, binding) {
		const { index, property, array, handler, exclude } = binding.value;

		const closeHandler = (event) => {
			if (
				!el.contains(event.target) &&
				event.target !== el &&
				!el.querySelector(exclude)?.contains(event.target)
			) {
				// Check if the index is valid within the array
				if (index >= 0 && index < array.length) {
					// Toggle the property value for the specified index
					array[index][property] = !array[index][property];
				}

				// Call the handler function with index as a parameter
				handler(index);
			}
		};

		el.__closableClickOutsideHandler = closeHandler;
		document.addEventListener("click", closeHandler);
	},
	unbind(el) {
		document.removeEventListener("click", el.__closableClickOutsideHandler);
		delete el.__closableClickOutsideHandler;
	},
});

let handleOutsideClick;
Vue.directive("closable", {
	bind(el, binding, vnode) {
		// Here's the click/touchstart handler
		// (it is registered below)
		handleOutsideClick = (e) => {
			e.stopPropagation();
			// Get the handler method name and the exclude array
			// from the object used in v-closable
			const { handler, exclude } = binding.value;
			// This variable indicates if the clicked element is excluded
			let clickedOnExcludedEl = false;
			exclude.forEach((refName) => {
				// We only run this code if we haven't detected
				// any excluded element yet
				if (!clickedOnExcludedEl) {
					let excludedEl = vnode.context.$refs[refName];
					excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;
					// Get the element using the reference name
					// See if this excluded element
					// is the same element the user just clicked on
					if (excludedEl) {
						// See if this excluded element
						// is the same element the user just clicked on
						clickedOnExcludedEl = excludedEl.contains(e.target);
					}
				}
			});
			// We check to see if the clicked element is not
			// the dialog element and not excluded
			if (!el.contains(e.target) && !clickedOnExcludedEl) {
				// If the clicked element is outside the dialog
				// and not the button, then call the outside-click handler
				// from the same component this directive is used in
				vnode.context[handler]();
			}
		};
		// Register click/touchstart event listeners on the whole page
		document.addEventListener("click", handleOutsideClick);
	},
	unbind() {
		// If the element that has v-closable is removed, then
		// unbind click/touchstart listeners from the whole page
		document.removeEventListener("click", handleOutsideClick);
	},
});
Vue.filter("sectionname", function(value) {
	if (value.length <= 16) {
		return value;
	} else {
		return value.slice(0, 15) + "...";
	}
});
